import { FRONT_CAMERA, VIDEO_INPUT } from './constants';

export async function getPreferredCameraId() {
  if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    console.warn('MediaDevices API not supported');
    return undefined;
  }

  try {
    await navigator.mediaDevices.getUserMedia({ video: true });

    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter((d) => d.kind === VIDEO_INPUT);
    // Prefer front-facing camera if label mentions it (available only after permission is granted once)
    const frontCamera = videoDevices.find((d) =>
      d.label.toLowerCase().includes(FRONT_CAMERA)
    );

    return (
      frontCamera?.deviceId ||
      videoDevices[1]?.deviceId ||
      videoDevices[0]?.deviceId
    );
  } catch (err) {
    console.error('Failed to list cameras:', err);
    return undefined;
  }
}
